export const DataSourcePrefix = 'datasource.';
